import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import client from '../../sanity/client';
import { useLanguage } from '../../components/LanguageContext';
import './SubPage.scss'
import { gsap } from 'gsap';
const SubPageBols = () => {
  const [bols, setBols] = useState([]);
  const [isAnimating, setIsAnimating] = useState(true);
  const { language } = useLanguage();

  // Titre statique multilingue
  const pageTitle = {
    fr: 'bols',
    en: 'bowls'
  };

useEffect(() => {
  const fetchData = async () => {
    const query = `*[_type == "subPageBols"] | order(order asc) {
      title,
      "imageUrl": image.asset->url,
      slug,
      order
    }`;
    const result = await client.fetch(query);
    setBols(result);
    setIsAnimating(false);
  };
  fetchData();
}, []);


  useEffect(() => {
    if (!isAnimating && bols.length > 0) {
      gsap.fromTo(
        '.gallery',
        { opacity: 0.2 },
        { opacity: 1, duration: 1.2, ease: 'power1.out' }
      );
    }
  }, [isAnimating, bols]);

  if (isAnimating) {
    return <div style={{ opacity: 0 }}>Loading...</div>;
  }

  return (
    <div className="sub-page">
      <h2>{pageTitle[language]}</h2>
      <div className="gallery">
        {bols.map((bol) => (
          bol.slug?.current ? (
            <div key={bol.slug.current} className="item">
              <Link to={`/ceramiste/bols/${bol.slug.current}`}>
                <img 
                  src={bol.imageUrl} 
                  alt={bol.title?.[language] || bol.title?.fr || bol.title?.en || 'Bol'} 
                />
              </Link>
            </div>
          ) : null
        ))}
      </div>
    </div>
  );
};
export default SubPageBols;